import React from 'react';
import '../css/LeadershipdataComp.css';
import {
  Stack,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Card
} from "@mui/material";
import { useSalesContext } from "../../../Pages/SalesContext";

// Static fallback JSON data
const dashboardData = {
  dashboardCards: [
    {
      card1: {
        Parameters: ["value1", "value2", "value3"],
        Norms: ["value1", "value2", "value3"],
        Actual: ["value1", "value2", "value3"]
      }
    },
    {
      card2: [
        { Label: "<=5%", Score: 0 },
        { Label: ">5%-<=10%", Score: 5 },
        { Label: ">10%-<=15%", Score: 10 },
        { Label: ">15%-<=20%", Score: 15 },
        { Label: ">20%", Score: 20 }
      ]
    }
  ]
};

const LeadershipdataComp: React.FC = () => {
  const { kpiData, loading } = useSalesContext();
  const card1 = dashboardData.dashboardCards[0].card1;
console .log("kpiData in LeadershipdataComp", kpiData.ParameterScore);
  // const card2 =
  //   Array.isArray(kpiData?.PoolSalesGrowth)
  //     ? kpiData.PoolSalesGrowth
  //     : dashboardData.dashboardCards[1].card2;

  const cardData =
    Array.isArray(kpiData?.ParameterScore)
      ? kpiData.ParameterScore
      : dashboardData.dashboardCards[0].card1;
  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <Box sx={{ p: 2 }} className="Leadership-container2">
      <Stack direction={{ xs: "column", sm: "row" }}>
        {/* Card 1 */}
        <Card
          className="Leadership-container"
          sx={{
            boxShadow: "none",
            marginTop: "10px",
            borderRadius: "8px"
          }}
        >
       <Box className="rectangle-box">
  <Box className="row">
    {["Parameters", "Norms", "Actual"].map((header, index) => (
      <Box key={header} sx={{ marginRight: 4 }}>
        <Typography
          variant="body1"
          sx={{
            color: "#1D1E1E",
            fontSize: "16px",
            fontWeight: 700,
            lineHeight: "18px",
            letterSpacing: "0.15px"
          }}
        >
          {header}
        </Typography>
{["TotalScore", "WorkHabit", "Sales"].map((field, i) => {
  let value = "";

  if (header === "Parameters") {
    value = field;
  } else if (header === "Norms" && cardData[0]) {
    const raw = cardData[0][field as keyof typeof cardData[0]];
    value = typeof raw === "number" ? Math.round(raw).toString() : "-";
  } else if (header === "Actual" && cardData[1]) {
    const raw = cardData[1][field as keyof typeof cardData[1]];
    value = typeof raw === "number" ? Math.round(raw).toString() : "-";
  }

  return (
    <Typography
      key={i}
      sx={{
        color: "#322B7C",
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.15px",
        marginTop: "14px",
        fontWeight: 700
      }}
    >
      {value}
    </Typography>
  );
})}

      </Box>
    ))}
  </Box>
</Box>

        </Card>
      </Stack>
    </Box>
  );
};

export default LeadershipdataComp;
